import { mapState, mapGetters, mapActions } from 'vuex'

export const appAuthComputed = {
  ...mapState('appAuth', {
    appSession: (state) => state.appSession,
  }),
  ...mapGetters('appAuth', ['appLoggedIn', 'updateCompanyInfo']),
}

export const appAuthMethods = mapActions(
  'appAuth', ['appLogIn', 'companyInfoExists'])


export const authComputed = {
  ...mapState('auth', {
    currentSession: (state) => state.currentSession,
    userRole: (state) => {
      let userRole = 'No especificado'
      const session = state.currentSession
      if (session.user.groups.length) {
        userRole = session.user.groups_detail[0].name
      }
      return userRole
    }
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions(
  'auth', ['logIn', 'logOut', 'register',
  'resetPassword', 'setUserActiveSection', 'logInTwoFactor', 'forgotPasswordAction',
  'resetPasswordAction'])

export const twoFactorAuthMethods = mapActions(
  'twoFactorAuth', ['sendEmailAuth', 'fetchQR', 'activateTotpAuth',
  'activateEmailAuth', 'fetchAuthDevices', 'deleteTotpAuth', 'deleteEmailAuth'])

export const languageComputed = {
  ...mapState('language', {
    language: (state) => state.language,
  })
}

export const languageMethods = mapActions(
  'language', ['setLanguage'])

export const usersComputed = {
  ...mapState('management/users', {
    cached: (state) => state.cached,
  }),
}

export const usersMethods = mapActions(
  'management/users', [
  'fetchUsers', 'createUpdateUsers',
  'deleteUsers', 'changePassword',
  'updatePhotos', 'fetchUsersDetail',
  'fetchUsersForOptions', 'checkIfUserExists',
  'registerUsers', 'changeFirstLoginAction']
)

export const permsComputed = {
  ...mapState('management/perms', {
    cached: (state) => state.cached,
  }),
}

export const permsMethods = mapActions(
  'management/perms', ['fetchPerms', 'createUpdatePerms',
  'deletePerms', 'fetchPermsDetail'])


export const groupsComputed = {
  ...mapState('management/groups', {
    cached: (state) => state.cached,
  }),
}

export const groupsMethods = mapActions(
  'management/groups', ['fetchGroups', 'createUpdateGroups',
  'deleteGroups', 'fetchGroupsDetail'])

export const appSectionsComputed = {
  ...mapState('management/appSections', {
    cached: (state) => state.cached,
  }),
}

export const appSectionsMethods = mapActions(
  'management/appSections', ['fetchAppSections', 'createUpdateAppSections',
  'deleteAppSections', 'fetchAppSectionsDetail'])



export const companyInfoComputed = {
  ...mapState('management/companyInfo', {
    cached: (state) => state.cached,
  }),
}

export const companyInfoMethods = mapActions(
  'management/companyInfo', ['fetchCompanyInfo', 'createUpdateCompanyInfo', 'setFileCompanyInfo'])

// Periodic tasks helpers
export const periodicTasksMethods = mapActions(
  'periodicTasks', ['fetchPeriodicTasks', 'createUpdatePeriodicTasks',
  'deletePeriodicTasks', 'fetchPeriodicTasksDetail', 'fetchPeriodicTasksOptions',
  'getLiveResultsPeriodicTasks', 'executeManuallyPeriodicTasks'])

export const periodicTasksResultsMethods = mapActions(
  'periodicTasksResults', ['fetchPeriodicTasksResults', 'createUpdatePeriodicTasksResults',
  'deletePeriodicTasksResults', 'fetchPeriodicTasksResultsDetail'])

export const periodicTasksSolarScheduleMethods = mapActions(
  'periodicTasksSolarSchedule', ['fetchPeriodicTasksSolarSchedule', 'createUpdatePeriodicTasksSolarSchedule',
  'deletePeriodicTasksSolarSchedule', 'fetchPeriodicTasksSolarScheduleDetail'])

export const periodicTasksIntervalScheduleMethods = mapActions(
  'periodicTasksIntervalSchedule', ['fetchPeriodicTasksIntervalSchedule', 'createUpdatePeriodicTasksIntervalSchedule',
  'deletePeriodicTasksIntervalSchedule', 'fetchPeriodicTasksIntervalScheduleDetail'])

export const periodicTasksClockedScheduleMethods = mapActions(
  'periodicTasksClockedSchedule', ['fetchPeriodicTasksClockedSchedule', 'createUpdatePeriodicTasksClockedSchedule',
  'deletePeriodicTasksClockedSchedule', 'fetchPeriodicTasksClockedScheduleDetail'])

export const periodicTasksCrontabScheduleMethods = mapActions(
  'periodicTasksCrontabSchedule', ['fetchPeriodicTasksCrontabSchedule', 'createUpdatePeriodicTasksCrontabSchedule',
  'deletePeriodicTasksCrontabSchedule', 'fetchPeriodicTasksCrontabScheduleDetail'])

// MANAGEMENT/MASTERS:

export const managementMastersTerritoriesMethods = mapActions(
  'management/masters/territories', ['fetchTerritories', 'createTerritories',
  'updateTerritories', 'deleteTerritories'])

export const managementMastersTerritoriesComputed = {
  ...mapGetters('management/masters/territories', ['getTerritoryFields']),
}

export const managementMastersSourcesMethods = mapActions(
  'management/masters/sources', ['fetchSources', 'createSources',
  'updateSources', 'deleteSources'])

export const managementMastersSourcesComputed = {
  ...mapGetters('management/masters/sources', ['getSourceFields']),
}

export const managementMastersLinesMethods = mapActions(
  'management/masters/lines', ['fetchLines', 'createLines',
  'updateLines', 'deleteLines'])

export const managementMastersLinesComputed = {
  ...mapGetters('management/masters/lines', ['getLineFields']),
}

export const managementMastersProjectsMethods = mapActions(
  'management/masters/projects', ['fetchProjects', 'createProjects',
  'updateProjects', 'deleteProjects',
  'fetchProjectsOptions'])
export const managementMastersProjectsComputed = {
  ...mapGetters('management/masters/projects', ['getProjectFields']),
}

export const managementMastersActivitiesMethods = mapActions(
  'management/masters/activities', ['fetchActivities', 'createActivities',
  'fetchActivitiesOptions', 'updateActivities', 'deleteActivities'])
export const managementMastersActivitiesComputed = {
  ...mapGetters('management/masters/activities', ['getActivityFields']),
}

export const managementMastersRequirementsMethods = mapActions(
  'management/masters/requirements', ['fetchRequirements', 'createRequirements',
  'updateRequirements', 'deleteRequirements'])
export const managementMastersRequirementsComputed = {
  ...mapGetters('management/masters/requirements', ['getActivitySubtaskFields']),
}

export const managementMastersDepartmentsComputed = {
  ...mapGetters('management/masters/departments', ['getDepartmentFields']),
}
export const managementMastersDepartmentsMethods = mapActions(
  'management/masters/departments', ['fetchDepartments', 'createDepartments',
  'updateDepartments', 'deleteDepartments'])

export const managementMastersMunicipalitiesComputed = {
  ...mapGetters('management/masters/municipalities', ['getMunicipalityFields']),
}
export const managementMastersMunicipalitiesMethods = mapActions(
  'management/masters/municipalities', ['fetchMunicipalities', 'createMunicipalities',
  'updateMunicipalities', 'deleteMunicipalities',
  'fetchMunicipalitiesByTerritory'])

export const managementMastersBanksComputed = {
  ...mapGetters('management/masters/banks', ['getBankFields']),
}
export const managementMastersBanksMethods = mapActions(
  'management/masters/banks', ['fetchBanks', 'createBanks',
  'updateBanks', 'deleteBanks'])



export const projectsAccountsMethods = mapActions(
  'projects/accounts', ['fetchAccounts', 'createUpdateAccount']
)

// MOCK API REST --> this is a fake API for test front-end without back-end
export const mockMethods = mapActions(
  'projects/mock', ['fetchAttendances',])


export const storesMethods = mapActions(
  'app/stores', ['fetchStores', 'createUpdateStores',
  'deleteStores'])

export const accessPointMethods = mapActions(
  'app/accessPoints', ['fetchAccessPoints', 'createUpdateAccessPoints',
  'deleteAccessPoints'])

  export const manageStoreMethods = mapActions(
    'management/store', ['fetchCompaniesList', 'fetchStores', 'createUpdateStore', 'fetchAccessPointsByStore', 'fetchTemplate', 'fetchTemplates', 'fetchReferences', 'fetchLabels', 'fetchItems',
                          'updateLabelSetTemplate', 'updateLabelSetItem', 'updateTemplateCode', 'taskTemplate',
                          'getInformation', 'getInformationDetail', 
                          'subscribeSSE', 'flashingLED','powerOFFScreen',

                          'createUpdateCompany',
                          'createUpdateAccessPoint',
                          'createUpdateLabel',
                          'createItem', 'createItemMassive', 'updateItem'
                        ]
  )
